import React, { useEffect, useState } from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Flex,
  VStack,
  Input,
  HStack,


} from '@chakra-ui/react';
import InsertTeacher from './Insert/InsertTeacher';
import { FaArrowLeft, FaArrowRight, FaEye, FaTrash } from 'react-icons/fa';
import axios from 'axios';
import { backendurl } from '../path';
import { useNavigate } from 'react-router-dom';
const TeacherData = () => {

    const [teachers,setteachers] = useState([]);
  // Dummy data for teachers

  
useEffect(() => {
const getdata = async()=>{
    const response = await axios.post(`${backendurl}/get-teachers`,{});
    console.log(response.data);
    setteachers(response.data);

}

getdata();

}, [])



  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();

  // Pagination
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = teachers.slice(indexOfFirstRow, indexOfLastRow);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const filteredteacher = searchTerm
  ? currentRows.filter((teacherone) =>
      teacherone.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
  : currentRows;

const handlevisit = (data)=>{
navigate(`/teacher/${data}`);
}

const handledelete = async(data)=>{
  const response = await axios.post(`${backendurl}/delete-teacher`,{"_id":data});
if(response.data.Deleted)
{
window.location.reload();
}
  }


  return (
    <VStack w={'100%'} mt={['20vh','25vh']} alignItems={'center'}  overflowX={'hidden'}>
        <Flex gap="4">
        <InsertTeacher/>
<Input placeholder='search name' value={searchTerm} onChange={(e)=>setSearchTerm(e.target.value)} />
        </Flex>
     

       
      <Table variant="striped" colorScheme="teal" w={'70%'} size={'sm'}>
       
        <Thead>
          <Tr>
            <Th>Teacher Name</Th>
            <Th>Teacher Contact</Th>
            <Th>Teacher Email</Th>
            <Th>Teacher Salary</Th>
            <Th>Teacher Date of Join</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {filteredteacher.map((teacher) => (
            <Tr key={teacher._id}>
              <Td>{teacher.name}</Td>
              <Td>{teacher.contact}</Td>
              <Td>{teacher.email}</Td>
              <Td>{teacher.salary}</Td>
              <Td>{teacher.doj}</Td>
              <Td ><HStack w={'full'} spacing={4}>
              <FaEye size={20} onClick={()=>handlevisit(teacher._id)} />
                <FaTrash size={20} onClick={()=>handledelete(teacher._id)} />
              </HStack></Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      <Flex justifyContent="space-between" mt={2} gap={4}>
        <Button onClick={() => paginate(currentPage - 1)} colorScheme={currentPage===1?'white':'orange'} disabled={currentPage === 1}><FaArrowLeft/></Button>
        <Button onClick={() => paginate(currentPage + 1)} disabled={indexOfLastRow >= filteredteacher.length}><FaArrowRight/></Button>
      </Flex>
  </VStack>
  );
};

export default TeacherData;
